export class WidgetColorConf {
    widget_header_background_color: string;
    widget_footer_background_color: string;
    widget_text_color: string;
    widget_footer_button_color: string;
    widget_header_active_color: string;
    widget_background_color: string;
}